import moment from 'moment';

export default (date, format) => {
	if (date) {
		if (!format) {
			format = 'Do MMM YYYY';
		}
		return moment(date).format(format);
	}
};
